import type { ComponentType } from 'react';

import type { PlayerStore } from '@iconik-io/unified-player-core';
import { useBasePlayerContext } from '@iconik-io/unified-player-ui-react';

export type UnifiedPlayerStore = {
  playerStore: PlayerStore;
};

export function withPlayerContext<T extends UnifiedPlayerStore>(
  Component: ComponentType<T>,
) {
  return function WrappedComponent(props: Omit<T, keyof UnifiedPlayerStore>) {
    const { store } = useBasePlayerContext();
    // TypeScript cannot relate `Omit<T, K> & Injected` back to `T` for a
    // generic `T`, which is what a higher-order component reassembles.
    // biome-ignore lint/plugin: see above.
    return <Component {...(props as T)} playerStore={store} />;
  };
}
